"use client";

import React, { useEffect, useState } from "react";

interface MeteorsProps {
  number?: number;
  minDelay?: number;
  maxDelay?: number;
  minDuration?: number;
  maxDuration?: number;
  angle?: number;
  className?: string;
}

export const Meteors = ({
  number = 20,
  minDelay = 0.2,
  maxDelay = 1.2,
  minDuration = 2,
  maxDuration = 10,
  angle = 215,
  className,
}: MeteorsProps) => {
  const [meteorStyles, setMeteorStyles] = useState<Array<React.CSSProperties>>(
    [],
  );

  useEffect(() => {
    // Create meteor styles
    const createMeteorStyles = () => {
      return [...new Array(number)].map(() => ({
        "--angle": -angle + "deg",
        top: "-5%",
        left: `calc(0% + ${Math.floor(Math.random() * window.innerWidth)}px)`,
        animationDelay: Math.random() * (maxDelay - minDelay) + minDelay + "s",
        animationDuration:
          Math.floor(Math.random() * (maxDuration - minDuration) + minDuration) +
          "s",
      }));
    };

    // Add keyframes style to head if it doesn't exist
    if (!document.getElementById("meteors-animation-style")) {
      const styleSheet = document.createElement("style");
      styleSheet.id = "meteors-animation-style";
      styleSheet.textContent = `
        @keyframes meteor {
          0% {
            opacity: 0;
            transform: scale(0.5) translate3d(0, 0, 0) rotate(var(--angle));
          }
          5% {
            opacity: 1;
          }
          20% {
            transform: scale(1) translate3d(calc(-100vw - 50vh), calc(100vh + 50vw), 0) rotate(var(--angle));
          }
          100% {
            transform: scale(1) translate3d(calc(-100vw - 50vh), calc(100vh + 50vw), 0) rotate(var(--angle));
            opacity: 0;
          }
        }
      `;
      document.head.appendChild(styleSheet);
    }

    setMeteorStyles(createMeteorStyles());

    // Handle window resize to adjust meteor positions
    const handleResize = () => {
      setMeteorStyles(createMeteorStyles());
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [number, minDelay, maxDelay, minDuration, maxDuration, angle]);

  return (
    <>
      {meteorStyles.map((style, idx) => (
        // Meteor Head
        <span
          key={idx}
          style={{ ...style }}
          className={`absolute size-0.5 rotate-[var(--angle)] animate-[meteor_var(--animation-duration)_linear_var(--animation-delay)_infinite] rounded-full bg-zinc-500 shadow-[0_0_0_1px_#ffffff10] ${className || ""}`}
        >
          {/* Meteor Tail */}
          <div className="pointer-events-none absolute top-1/2 -z-10 h-px w-[50px] -translate-y-1/2 bg-gradient-to-r from-zinc-500 to-transparent" />
        </span>
      ))}
    </>
  );
};